import CustomerMap from './api/CustomerMap'

export default (ctx, inject) => {
  inject('map', new CustomerMap())
}
